import React from "react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-7">
      <div>
        {subtitle && <p className="overline mb-1.5">{subtitle}</p>}
        <h1 className="font-display text-3xl font-medium tracking-tight text-foreground">{title}</h1>
      </div>
      {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
    </div>
  );
}
